import Model from './Model';

export default class EvaluationStudents extends Model {
    id;
    name;
    first_name;
    last_name;
    diplomas;

    static apiPath() {
        return 'students';
    }

    toJson() {
        // When submitting an change, we need to send id's for the relations instead of the values themselves.
        const dtoIds = {
            id: this.id
        };

        return { ...this, ...dtoIds };
    }
}



// WEBPACK FOOTER //
// ./src/models/EvaluationStudents.js